import { manageAppointmentsActionTypes } from "../constants/ApiConstants";

const initialState = {
  loading: false,
  appointmentList: null,
  signed_appointmentList: null,
  signedAndComplete_appointmentList: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case manageAppointmentsActionTypes.get_patient_appointment_list.REQUEST:
      return {
        ...state,
        loading: true,
        appointmentList: null
      };
    case manageAppointmentsActionTypes.get_patient_appointment_list.SUCCESS:
      return {
        ...state,
        loading: false,
        appointmentList: payload
      };
    case manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignatures.REQUEST:
      return {
        ...state,
        loading: true,
        signed_appointmentList: null
      };
    case manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignatures.SUCCESS:
      return {
        ...state,
        loading: false,
        signed_appointmentList: payload
      };
      case manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignaturesAndComplete.REQUEST:
      return {
        ...state,
        loading: true,
        signedAndComplete_appointmentList: null
      };
    case manageAppointmentsActionTypes.post_saveBatchEncounterGuardianSignaturesAndComplete.SUCCESS:
      return {
        ...state,
        loading: false,
        signedAndComplete_appointmentList: payload
      };
      default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/ManageAppointments/components/appointments/reducers/index.js